<template>
    <b-dropdown variant="light" :text="placeholder" @hidden="hide()" @shown="inputFocus()">
        <span slot="button-content"><i class="fa-icon" :class="faIcon"></i> {{placeholder}}</span>
        <div class="dropdown-header" v-if="searchbar">
            <input data-hj-whitelist v-model="search" class="form-control form-control-sm" type="search" :placeholder="searchPlaceholder"/>
        </div>
        <div class="overflow-scroll">
            <template v-for="option in filteredData">
                <b-form-checkbox data-hj-whitelist
                                 class="dropdown-item"
                                 v-model="checked"
                                 :value="option"
                                 @change="changed">{{option.label}}</b-form-checkbox>
                <div class="dropdown-divider" v-if="option.value === null"></div>
            </template>
        </div>
    </b-dropdown>
</template>

<script>

    export default {
        components: {

        },
        props: {
            data: {
                type: Array,
                required: true
            },
            placeholder: {
                type: String,
                default: 'Selecteer'
            },
            searchbar: {
                type: Boolean,
                default: false
            },
            searchPlaceholder: {
                type: String,
                default: 'Zoeken'
            },
            value: {
                type: Object|Array
            },
            faIcon: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                search: '',
                checked: [],
            }
        },
        watch: {
            value(value) {
                this.checked = value;
            }
        },
        beforeDestroy() {
        },
        mounted() {
            this.popupItem = this.$el
        },
        computed: {
            filteredData() {
                let s = this.search;
                return this._.filter(this.data, function(o) {
                    return s.length === 0 || o.label.toLowerCase().indexOf(s.toLowerCase()) >= 0;
                });
            }
        },
        methods: {
            hide () {
                this.$emit('input', this.checked);
            },
            changed() {
            },
			inputFocus() {
				this.$el.getElementsByTagName('input')[0].focus();
			}
        }
    }
</script>

<style lang="scss">
    @import "../../../sass/variables";

    .overflow-scroll {
        max-height: 400px;
        overflow-y: scroll;
    }

    .dropdown-item.custom-checkbox {
        padding-top: 0;
        padding-bottom: 0;
    }

    .dropdown-item.custom-checkbox .custom-control-label {
        width: 100%;
        height: 100%;
        margin-left: 10px;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .dropdown-item.custom-checkbox .custom-control-label::before, .dropdown-item.custom-checkbox .custom-control-label::after {
        margin-top: 4px;
    }

    .fa-icon {
        font-size: 13px;
        margin-right: 3px;
        color: $primary;
    }
</style>